import { c as _c } from "react/compiler-runtime";
import React, { startTransition, useEffect, useState } from "react";
import { SidebarMenu, SidebarMenuItem } from "@components/ui/sidebar";
import { useAppSelector } from "@lib/redux/hooks";
import { selectAuth, selectSessionUser } from "@features/application/app-selectors";
import { NavUserInfo } from "@features/auth/ui/nav-user-info";
import { NavUserLogin } from "@features/auth/ui/nav-user-login";
import { NavUserSkeleton } from "@features/auth/ui/nav-user-skeleton";
export const NavUser = t0 => {
  const $ = _c(17);
  const {
    isPrivateMode: t1
  } = t0;
  const isPrivateMode = t1 === undefined ? false : t1;
  const user = useAppSelector(selectSessionUser);
  const {
    isAuthenticated
  } = useAppSelector(selectAuth);
  const [isLoaded, setIsLoaded] = useState(false);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      startTransition(() => {
        setIsLoaded(true);
      });
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== isAuthenticated) {
    t3 = [isAuthenticated];
    $[1] = isAuthenticated;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] !== isLoaded) {
    t4 = !isLoaded && <NavUserSkeleton />;
    $[3] = isLoaded;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== isAuthenticated || $[6] !== isLoaded || $[7] !== isPrivateMode || $[8] !== user) {
    t5 = isLoaded && isAuthenticated && user && <NavUserInfo user={user} isPrivateMode={isPrivateMode} />;
    $[5] = isAuthenticated;
    $[6] = isLoaded;
    $[7] = isPrivateMode;
    $[8] = user;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== isAuthenticated || $[11] !== isLoaded) {
    t6 = isLoaded && isAuthenticated === false && <NavUserLogin />;
    $[10] = isAuthenticated;
    $[11] = isLoaded;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t7 = <SidebarMenu><SidebarMenuItem>{t4}{t5}{t6}</SidebarMenuItem></SidebarMenu>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};